import { render, staticRenderFns } from "./DisappointmentBeckInterpretation.vue?vue&type=template&id=1d32f214&scoped=true"
import script from "./DisappointmentBeckInterpretation.vue?vue&type=script&lang=js"
export * from "./DisappointmentBeckInterpretation.vue?vue&type=script&lang=js"
import style0 from "./DisappointmentBeckInterpretation.vue?vue&type=style&index=0&id=1d32f214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d32f214",
  null
  
)

export default component.exports